import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { newsArticles, formatDate } from '../data/news';
import { PartnerCTA } from '../components/PartnerCTA';
const ARTICLES_PER_PAGE = 6;
export function NewsPage() {
  const [visibleCount, setVisibleCount] = useState(ARTICLES_PER_PAGE);
  const sortedArticles = [...newsArticles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  const visibleArticles = sortedArticles.slice(0, visibleCount);
  const hasMore = visibleCount < sortedArticles.length;
  const handleLoadMore = () => {
    setVisibleCount(prev => prev + ARTICLES_PER_PAGE);
  };
  return <>
      <PageHero label="About Us" title="News and Insights" subtitle="Updates, announcements and insights from Chiltern Global." data-id="element-1065" />

      <Breadcrumbs items={[{
      label: 'About Us',
      to: '/about'
    }, {
      label: 'News and Insights'
    }]} data-id="element-1066" />

      {/* Articles Grid */}
      <section className="bg-white py-24" data-id="element-1067">
        <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1068">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1069">
            {visibleArticles.map(article => <Link key={article.slug} to={`/about/news/${article.slug}`} className="bg-white border border-steel-200 rounded-sm overflow-hidden hover:border-cg-orange-600 transition-colors group flex flex-col" data-id="element-1070">
                {/* Image */}
                <div className="aspect-[16/10] overflow-hidden bg-slate-100" data-id="element-1071">
                  <img src={article.heroImage} alt={article.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-1072" />
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-1" data-id="element-1073">
                  <div className="flex items-center gap-3 mb-3" data-id="element-1074">
                    <span className="text-[10px] font-bold uppercase tracking-wider text-cg-orange-600" data-id="element-1075">
                      {article.category}
                    </span>
                    <span className="text-[10px] text-steel-400" data-id="element-1076">
                      {formatDate(article.date)}
                    </span>
                  </div>

                  <h2 className="text-lg font-bold text-navy-900 mb-3 group-hover:text-cg-orange-600 transition-colors line-clamp-2" data-id="element-1077">
                    {article.title}
                  </h2>

                  <p className="text-sm text-steel-600 leading-relaxed mb-4 flex-1 line-clamp-3" data-id="element-1078">
                    {article.excerpt}
                  </p>

                  <span className="text-xs font-bold text-navy-900 uppercase tracking-wider flex items-center gap-1 group-hover:text-cg-orange-600 transition-colors" data-id="element-1079">
                    Read more{' '}
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" data-id="element-1080" />
                  </span>
                </div>
              </Link>)}
          </div>

          {/* Load More */}
          {hasMore && <div className="mt-12 text-center" data-id="element-1081">
              <button onClick={handleLoadMore} className="inline-flex items-center justify-center px-8 py-4 border border-navy-900 text-navy-900 hover:bg-navy-900 hover:text-white font-bold uppercase tracking-wider text-sm rounded-sm transition-colors" data-id="element-1082">
                Load more articles
              </button>
            </div>}
        </div>
      </section>

      <PartnerCTA data-id="element-1083" />
    </>;
}